import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { AccessGate } from './AccessGate';
import { FullScreenLoader } from './ui';

/** Must be signed in. */
export function RequireAuth() {
  const { status } = useAuth();
  const location = useLocation();
  if (status === 'loading') return <FullScreenLoader />;
  if (status === 'unauthenticated') return <Navigate to="/signin" replace state={{ from: location }} />;
  return <Outlet />;
}

/** Must be an active member (instructors pass via the gate result). */
export function RequireActive() {
  const { gate } = useAuth();
  if (gate && !gate.allowed) return <AccessGate />;
  return <Outlet />;
}

/** Must be an instructor. */
export function RequireInstructor() {
  const { user } = useAuth();
  if (!user || user.role !== 'instructor') return <Navigate to="/" replace />;
  return <Outlet />;
}
